module.exports = __webpack_public_path__ + "static/media/occubound.af800a26.gif";